import { ControllingFilters } from '@myapp/contract'
import { normalizeFilters } from '../../../shared/lib/normalizeFilters'

export const controllingKeys = {
  all: ['controlling'] as const,
  lists: () => [...controllingKeys.all, 'list'] as const,
  list: (filters?: ControllingFilters) =>
    [...controllingKeys.lists(), normalizeFilters(filters)] as const,
}
